import React, { useMemo } from 'react';
import Badge from '../../common2/Badge';
import { ConsumerActionStatus } from '../../../api/types';
import { ClaimType } from '../../parcel-finder/claims/types';
import Tooltip from '../../common/Tooltip';
import { Locale } from '../../Translate';
import nanoid from 'nanoid';

const consumerActionStatusTitleIntent: Record<
  ConsumerActionStatus,
  { intent: 'warning' | 'positive' | 'alert'; title: string }
> = {
  [ConsumerActionStatus.PENDING]: {
    intent: 'warning',
    title: 'Pending',
  },
  [ConsumerActionStatus.COMPLETED]: {
    intent: 'positive',
    title: 'Completed',
  },
  [ConsumerActionStatus.REJECTED]: {
    intent: 'alert',
    title: 'Rejected',
  },
  [ConsumerActionStatus.EXPIRED]: {
    intent: 'alert',
    title: 'Expired',
  },
};

type Props = {
  consumerActionStatus: ConsumerActionStatus | null;
  claimType?: ClaimType;
};

function ConsumerActionStatusBadge({ consumerActionStatus, claimType }: Props) {
  const id = useMemo(() => nanoid(), []);

  if (!consumerActionStatus) {
    return null;
  }

  const badgeData = consumerActionStatusTitleIntent[consumerActionStatus];

  if (!claimType) {
    return <Badge intent={badgeData.intent}>{badgeData.title}</Badge>;
  }

  const tooltipText =
    claimType === ClaimType.INVESTIGATION
      ? 'CONSUMER_ACTION_STATUS_BADGE_TOOLTIP_EDOR'
      : 'CONSUMER_ACTION_STATUS_BADGE_TOOLTIP_PHOTO_UPLOAD';

  return (
    <span data-tip data-for={id}>
      <Badge intent={badgeData.intent}>{badgeData.title}</Badge>
      <Tooltip id={id} position="top">
        <Locale>{tooltipText}</Locale>
      </Tooltip>
    </span>
  );
}

export default React.memo(ConsumerActionStatusBadge);
